export * from './typography-without-id'
